<script>
  import { onMount } from "svelte";

  import { ignore } from "../../../Common/tools";
  import {External, M} from "../../../external";

  export let data = {};
  export let valid = false;
  export let onChange = ignore;

  let selectedKeyUnit;
  let selectedValueAmount;
  let selectedValueTime;
  let selectedKey;
  let timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;

  let onValueChange = () => {
    if (selectedKey === "relative") {
      data.settings = [
        {
          key: selectedKeyUnit,
          value: selectedValueAmount
        }
      ];

      if (selectedValueAmount && (selectedValueAmount + "").trim().length > 0) {
        valid = true;
        data.name = "" + selectedValueAmount + " " + M[selectedKeyUnit.toUpperCase()];
      }
    } else if (selectedKey === "exact") {
      data.settings = [
        {
          key: "exact",
          value: selectedValueTime + ""
        }
      ];

      if (selectedValueTime && (selectedValueTime + "").length > 0) {
        valid = true;

        data.name = External.Tools.dateToString(new Date(selectedValueTime), true, true);
      }
    } else if (selectedKey === "condition") {
      valid = false;
    } else {
      valid = false;
    }
    if (valid) {
      onChange();
    }
  };

  let executeDate = (node) => {
    const target = External.$(node);
    target.datetimepicker({
      minDate: new Date(),
      dateFormat: External.WebsiteSettings.getDateFormat() === "us" ? "mm/dd/yy" : "dd/mm/yy",
      currentText: M.TIME_NOW,
      closeText: M.CLOSE,
      timeText: M.TIME,
      hourText: M.TIME_HOUR,
      minuteText: M.TIME_MINUTE,
      secondText: M.SECONDS,
      monthNamesShort: [M.JAN, M.FEB, M.MAR, M.APR, M.MAY_SHORT, M.JUN, M.JUL, M.AUG, M.SEP, M.OCT, M.NOV, M.DEC],
      monthNames: [M.JANUARY, M.FEBRUARY, M.MARCH, M.APRIL, M.MAY, M.JUNE, M.JULY, M.AUGUST, M.SEPTEMBER, M.OCTOBER, M.NOVEMBER, M.DECEMBER],
      onSelect: function (dateText) {
        let date = External.$(this).datepicker("getDate");
        // just get the UTC milliseconds from that date. The calendar sets it to midnight in current timezone...
        selectedValueTime = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()) + timezoneOffset;
        onValueChange();
      }
    }); //.datepicker('setDate', new Date());

    if (selectedValueTime && selectedValueTime > 9000) {
      target.datepicker("setDate", new Date(selectedValueTime));
    }

    return {
      destroy() {
        target.datepicker("destroy");
      }
    };
  };

  onMount(function () {
    if (!data) {
      data = {};
    }

    if (!data.settings) {
      data.settings = [];
    }
    let settings = data.settings[0];

    if (settings && settings.key === "exact") {
      selectedKey = "exact";
      selectedValueTime = +settings.value;
      valid = true;
    } else if (settings && settings.key) {
      selectedKey = "relative";
      selectedKeyUnit = settings.key;
      selectedValueAmount = settings.value;
      valid = true;
    } else {
      valid = false;
    }
  });
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{M.DELAY_DESC}</h4>
  <div class="multiple-items-picker mt-25 mb-5">
    <div class="label">
      <div class="col20 f-left mt-5">
        <div class="checkbox-wrapper mt-25 mb-5">
          <input id="automations-delay-step-relative" bind:group={selectedKey} on:change={onValueChange} value="relative" class="css-checkbox" type="radio" />
          <label for="automations-delay-step-relative" class="css-label">{M.DELAY_TIME}</label>
        </div>
      </div>
      <div class="col20 f-left mt-5">
        <div class="checkbox-wrapper mb-5">
          <input id="automations-delay-step-exact" bind:group={selectedKey} on:change={onValueChange} value="exact" class="css-checkbox" type="radio" />
          <label for="automations-delay-step-exact" class="css-label">{M.DELAY_EXACT}</label>
        </div>
      </div>
      <div class="col20 f-left mt-5">
        <div class="checkbox-wrapper mb-5">
          <input id="automations-delay-step-condition" bind:group={selectedKey} on:change={onValueChange} value="condition" class="css-checkbox" type="radio" />
          <label for="automations-delay-step-condition" class="css-label">{M.DELAY_CONDITION}</label>
        </div>
      </div>
    </div>
  </div>
  {#if selectedKey === "relative"}
    <div class="multiple-items-picker mt-25 mb-25">
      <span class="help-text-left col20 t-left f-left mt-25 mb-5">{M.DELAY_RELATIVE_DESC}</span>
      <div class="input-wrapper input-wrapper2 f-left mb-5">
        <input on:keyup={onValueChange} on:change={onValueChange} type="number" min="1" step="1" class="transition-border" placeholder={M.ENTER_DELAY} bind:value={selectedValueAmount} />
      </div>
      <div class="input-wrapper input-wrapper2 f-right mb-5">
        <select on:change={() => setTimeout(onValueChange, 1)} class="page-select" bind:value={selectedKeyUnit}>
          <option value="days">{M.DAYS}</option>
          <option value="hours">{M.HOURS}</option>
          <option value="minutes">{M.MINUTES}</option>
        </select>
      </div>
    </div>
  {:else if selectedKey === "exact"}
    <div class="multiple-items-picker mt-25 mb-25">
      <span class="help-text-left col20 t-left f-left mt-25 mb-5">{M.DELAY_EXACT_DESC}</span>
      <div class="popup-input-wrapper email-date-input-wrapper mb-15">
        <input use:executeDate type="text" class="datepicker" placeholder={M.SELECT_DATE_TIME} />
      </div>
    </div>
  {:else if selectedKey === "condition"}
    <div class="multiple-items-picker mt-25 mb-25">
      <div class="col20 f-left t-center mb-5 mt-15">
        <span class="material-icons-outlined fingerprint-icon" style="font-size: 26px;"> warning </span>
      </div>
      <h5 class="col20 f-left ta-center mt-15" style="font-size: 14px;">{M.COMING_SOON}</h5>
    </div>
  {/if}
  <div class="col20 f-left gray-section product-select-wrapper mt-25 none">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">Applied to everyone</h4>
      <a class="text-link blue-text" data-role="changeTextStyles">Change</a>
    </div>
  </div>
</div>
